import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Dropzone from 'react-dropzone'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { MAX_SCAN_FILE_SIZE } from '../../state/file-upload/const'
import { formatDateTime } from '../../../../util/datetime'
import { BACKEND_URL } from '../../../../util/api'
import BlockUi from 'react-block-ui'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CBCT_FILE_UPLOAD_WIDGET } from '../../../process/ui-definition/process-ui'
import Table from '../../../form/component/Table'
import { getDroppedOrSelectedFiles } from '../../util/upload-helper';

const style = {
    width: '100%',
    height: '200px',
    borderWidth: '2px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
    padding: '35px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '32px',
}

const VIEW_URL = BACKEND_URL + '/api/file-system/view-file?fileId='
const DOWNLOAD_URL = BACKEND_URL + '/api/file-system/download-file?fileId='
const DOWNLOAD_ALL_URL = BACKEND_URL + '/api/file-system/download-cbct-files?customerId='

const getColumnList = (fileType, setDeleteFlag, onFileDeleteFlagSuccess) => {
    return [
        {
            property: 'fileName',
            header: 'File name',
        },
        {
            property: 'uploaded',
            header: 'Uploaded',
            renderer: file => {
                return formatDateTime(file.created)
            },
        },
        {
            property: 'download',
            header: 'Download',
            renderer: file => {
                return <a href={ DOWNLOAD_URL + file.id}>download</a>
            },
        },
        {
            property: 'view',
            header: 'View',
            renderer: file => {
                return <a href={VIEW_URL + file.id} target="_blank" rel="noopener noreferrer">view</a>
            },
        },
        {
            property: 'createdByUser',
            header: 'Uploaded By',
        },
        {
            property: 'delete',
            header: 'Delete',
            renderer: file => {
                return <button
                    onClick={() => {
                        setDeleteFlag(file.id, onFileDeleteFlagSuccess)
                    }}
                    className="btn btn-primary btn-sm">delete
                </button>
            },
        },
    ]
}

const UploadedFileTable = ({ fileList, fileType, readOnly, setDeleteFlag, onFileDeleteFlagSuccess, tableSetting, changeTableSetting }) => {
    if (!fileList) {
        return null
    }

    return (
        <Table
            columnList={getColumnList(fileType, setDeleteFlag, onFileDeleteFlagSuccess)}
            changeTableSetting={changeTableSetting}
            tableSetting={tableSetting}
            rowList={fileList}
            idProperty="id"
        />
    )
}


const CbctFileUpload = ({ customer, fileType, uploadCustomerFile, onUploadSuccess, setDeleteFlag, onFileDeleteFlagSuccess, fetching, tableSetting, changeTableSetting }) => {
    if (!currentUserHasAccess(CBCT_FILE_UPLOAD_WIDGET) || !customer) {
        return null
    }

    const fileList = customer[fileType].filter(file => {
        return !file.deleted
    })

    return (
        <BlockUi tag="div" blocking={fetching}>
            <ContentBox title="CBCT Files">
                {
                    fileList.length !== 0 && (
                        <Row bottom="S">
                            <Column size={12}>
                                <a href={DOWNLOAD_ALL_URL + customer.id} className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer">Download all <i className="fa fa-cloud-download"/></a>
                            </Column>
                        </Row>
                    )
                }
                <Row>
                    <Column>
                        <UploadedFileTable
                            onFileDeleteFlagSuccess={onFileDeleteFlagSuccess}
                            setDeleteFlag={setDeleteFlag}
                            fileType={fileType}
                            fileList={fileList}
                            tableSetting={tableSetting}
                            changeTableSetting={changeTableSetting}
                        />
                    </Column>
                </Row>
                {uploadCustomerFile !== undefined && (<Row>
                    <Column size={12}>
                        <Dropzone
                            multiple={true}
                            maxSize={MAX_SCAN_FILE_SIZE}
                            style={style}
                            disablePreview={true}
                            getDataTransferItems={evt =>
                                getDroppedOrSelectedFiles(evt).then(list =>
                                    list.map(({ fileObject, ...rest }) => fileObject)
                                )
                            }
                            onDrop={(fileList) => {
                                uploadCustomerFile(fileList, customer.id, fileType, onUploadSuccess)
                            }}>
                            <p>Click to upload a file</p>
                        </Dropzone>

                    </Column>

                </Row>)}
            </ContentBox>
        </BlockUi>
    )
}


CbctFileUpload.propTypes = {
    customer: PropTypes.object,
    fileType: PropTypes.string,
    uploadCustomerFile: PropTypes.func,
    onUploadSuccess: PropTypes.func.isRequired,
    setDeleteFlag: PropTypes.func.isRequired,
    onFileDeleteFlagSuccess: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
}

export default CbctFileUpload



// WEBPACK FOOTER //
// ./src/modules/customer/component/cbct-file-upload/CbctFileUpload.js